export const setStringToLower = (param: string) => {
   return param.toLowerCase()
}
